import { createAction } from '@reduxjs/toolkit';
export const PICK_PARKED_CALL = 'PICK_PARKED_CALL';
export const pickParkedCallAction = createAction(PICK_PARKED_CALL);